import axios from 'axios';
import apiInstance from './RefeshTokenInstance';

const APP_BASE_URL = `${process.env.REACT_APP_BASE_URL}/api`;

export const addProperty = async (formDataToSend: FormData) => {
  const API_URL = `${APP_BASE_URL}/createProperty`;

  try {
    const response = await apiInstance.post(API_URL, formDataToSend, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });

    return response;
  } catch (error) {
    console.error('Error uploading property:', error);
    throw error;
  }
};

export const getProperties = async (UserID: string) => {
  const API_URL = `${APP_BASE_URL}/properties/${UserID}`;
  try {
    const response = await apiInstance.get(API_URL);

    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteProperty = async (
  userId: number | string | (number[] | string[])
): Promise<any> => {
  const userIdArray = Array.isArray(userId) ? userId : [userId];

  const API_URL = `${APP_BASE_URL}/deteleProperty/${userIdArray.join(',')}`;

  try {
    const response = await apiInstance.delete(API_URL);

    return response;
  } catch (error) {
    throw error;
  }
};

export const updateProperties = async (PropertyId: string, values: any) => {
  const API_URL = `${APP_BASE_URL}/updateProperty/${PropertyId}`;
  try {
    const response = await apiInstance.put(API_URL, values, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response;
  } catch (error) {
    console.error('Error in updateProperties:', error);
    throw error;
  }
};

export const GetpropertyByID = async (PropertyId: string) => {
  const API_URL = `${APP_BASE_URL}/Getproperty/${PropertyId}`;
  try {
    const response = await apiInstance.get(API_URL);
    return response;
  } catch (error) {
    console.error('Error in updateProperties:', error);
    throw error;
  }
};

export const GetTrackpropertyLink = async (
  Shorturl: string,
  userLocation: {
    ip: string;
    city: string;
    region: string;
    country: string;
    loc: string;
    org: string;
    postal: string;
    timezone: string;
    latitude: string;
    longitude: string;
    role: string;
    shouldCount?: boolean; // ✅ Added this optional field
  }
) => {
  const API_URL = `${APP_BASE_URL}/getTrack/:${Shorturl}`;
  try {
    const response = await apiInstance.post(API_URL, userLocation);
    return response;
  } catch (error) {
    throw error;
  }
};
export const deleteImages = async (
  images: string | string[],
  PropertyId: string
): Promise<any> => {
  const imagesArray = Array.isArray(images) ? images : [images];

  const API_URL = `${APP_BASE_URL}/deleteImages/${PropertyId}`;

  try {
    const response = await apiInstance.delete(API_URL, {
      data: { images: imagesArray },
      headers: { 'Content-Type': 'application/json' }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteFiles = async (
  files: string | string[],
  PropertyId: string
): Promise<any> => {
  const filesArray = Array.isArray(files) ? files : [files];

  const API_URL = `${APP_BASE_URL}/deleteFiles/${PropertyId}`;

  try {
    const response = await apiInstance.delete(API_URL, {
      data: { files: filesArray },
      headers: { 'Content-Type': 'application/json' }
    });
    return response;
  } catch (error) {
    throw error;
  }
};
